<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Editar Programa") }}
        {{ $t("ID") }} #{{ item.id }}
      </h1>
    </div>
    <load v-if="loading" />
    <div class="col-md-12" v-else>
      <div v-if="historicoStatus == false">
        <div class="card mb-0 shadow card-body">
          <form @submit.prevent="submit" ref="addItem">
            <div class="row">
              <form-input
                v-model="item.nome"
                grid="8"
                label="Nome do Programa"
                :required="true"
                :disabled="item.id >= 23 ? false : true"
              />

              <form-input
                v-model="item.valor"
                grid="4"
                inputGroup="true"
                btnText="R$"
                :type="'number'"
                label="Valor"
                min="0"
              />

              <form-toggle
                grid="12"
                mt="0"
                v-model="item.gerenciado"
                label="Deseja fazer a gestão dos pagamentos deste programa?"
              />

              <form-input
                v-if="item.gerenciado"
                v-model="item.dia_pagamento"
                grid="4"
                label="Dia do mês para pagamento"
                :type="'number'"
              />
              <form-input
                v-if="item.gerenciado"
                v-model="item.num_parcelas"
                grid="4"
                label="Parcelas"
                :type="'number'"
              />

              <form-select
                v-if="item.gerenciado"
                v-model="item.origem"
                grid="4"
                label="Fonte do Recurso"
                :itens="$root.arrays.origem_beneficio"
              />

              <form-textarea-editor
                v-model="item.observacoes"
                label="Mais detalhes sobre o Programa"
              />

              <form-select
                @change="verificarStatus"
                v-model="item.status"
                label="Status"
                grid="12"
                :itens="status"
              />
            </div>

            <div class="row pt-4 px-0 d-flex justify-content-between">
              <div class="col-auto px-2 text-left">
                <span class="py-2 px-2">
                  {{ item.beneficiados }} beneficiado(s)
                </span>
                <span class="py-2 px-2">
                  - R$ {{ item.valor_total }} pago(s) mensalmente
                </span>
              </div>
              <div class="col-auto px-2 text-right">
                <a
                  class="router-link-exact-active active px-3"
                  @click="historicoStatus = true"
                >
                  <i class="fas fa-history"></i> Histórico de Status
                </a>
                <router-link
                  to="/dashboard/programassociais/"
                  class="btn btn-default"
                >
                  <i class="mdi mdi-arrow-left" />
                </router-link>

                <button
                  class="btn btn-success btn-submit"
                  data-style="zoom-in"
                  type="submit"
                  @click="submit"
                >
                  <i class="mdi mdi-content-save" />
                  {{ $t("Salvar") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="animate__animated animate__fadeIn" v-else>
        <div class="card mb-0 shadow card-body">
          <HistoricoStatus
            @voltar="historicoStatus = false"
            :id="item.id"
            :familia="0"
            :status="status_item"
          />
        </div>
      </div>

      <status-historico
        :model="model"
        modulo="ProgramaSocial"
        titulo_modulo="PROGRAMAS SOCIAIS"
        :id="item.id"
        :status-anterior="statusAnterior"
        :status-atual="statusAtual"
        :status="status_item"
        @submit="submit"
      />

      <Read :programa="this.item" />
    </div>
  </div>
</template>

<script>
import Read from "./programafamilia/ReadBeneficiariosPrograma";
import HistoricoStatus from "./HistoricoStatus";
export default {
  name: "Edit",
  components: {
    HistoricoStatus,
    Read,
  },
  data() {
    return {
      loading: true,
      statusAtual: "",
      statusAnterior: "",
      historicoStatus: false,
      status: {},
      status_item: [],
      model: "ProgramaSocial",
      item: {},
    };
  },
  mounted() {
    this.getStatus();
    this.getItem();
    this.getStatusFinais();
  },
  methods: {
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/programassociais/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          this.statusAnterior = this.item.status;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
    getStatus() {
      axios.get(`api/dashboard/status/programassociais`).then((response) => {
        this.status = response.data;
      });
    },
    verificarStatus(status) {
      this.statusAtual = status;

      const result = this.status_item.filter((item) => item.id == status);
      if (result[0].final == 1) {
        //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
        this.$bvModal.show("status-historico-" + this.model);
      }
    },
    getStatusFinais() {
      axios
        .post(`api/dashboard/get/status/finais`, {
          model: this.model,
          module: this.model,
        })
        .then((response) => {
          this.status_item = response.data;
        });
    },
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      axios
        .put("api/dashboard/programassociais/" + this.item.id, this.item)
        .then((response) => {
          ladda.stop();
          this.getItem();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        });
    },
  },
};
</script>
